import { makeStyles } from 'tss-react/mui';

/** Fixed badge height — keeps all variants the same size. */
const BADGE_HEIGHT_PX = 24;

export default makeStyles()((theme) => ({
  link: {
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'none',
      cursor: 'pointer',
    },
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(10),
    fontWeight: 'bold',
    lineHeight: 1,
    boxSizing: 'border-box',
    height: theme.typography.pxToRem(BADGE_HEIGHT_PX),
    padding: theme.spacing(0, 0.75),
    display: 'inline-flex',
    alignItems: 'center',
    width: 'fit-content',
    whiteSpace: 'nowrap',
  },
  badgeContent: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    height: '100%',
  },
  blackText: {
    color: theme.palette.common.black,
  },
  whiteText: {
    color: theme.palette.common.white,
  },
  yellowBackground: {
    backgroundColor: theme.palette.custom.yellow,
  },
  blackBackground: {
    backgroundColor: theme.palette.common.black,
  },
  blueBackground: {
    backgroundColor: '#2196F3',
  },
  icon: {
    fontSize: '1em !important',
    width: '1em',
    height: '1em',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      display: 'block',
    },
  },
  labelContent: {
    display: 'block',
    lineHeight: 1,
    // Trim descender gap so flex centers cap height, not the full em-box (modern browsers).
    '@supports (text-box-trim: trim-both)': {
      textBoxTrim: 'trim-both',
      textBoxEdge: 'cap alphabetic',
    },
    // Fallback: nudge caps down to align with the star's visual center (Roboto ~14% em).
    '@supports not (text-box-trim: trim-both)': {
      transform: 'translateY(0.14em)',
    },
  },
}));
